var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYlwsjg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 69",
    className: "design-iconfont",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "98.993048%",
    id: "6j85fnrt5c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71ECDA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B8C0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "1t7pqdzlnb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98F3E7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66D0D5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-44%",
    y: "-37%",
    width: "187.9%",
    height: "173.9%",
    filterUnits: "objectBoundingBox",
    id: "vhd6d7wwqa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#vhd6d7wwqa)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,4 C34.3506307,4 40.0997889,6.58913593 44.2614593,10.7744092 C48.4251707,14.9617352 51,20.7466044 51,27.1361163 C51,32.6616494 47.5782888,39.4412816 43.3475291,45.410863 C37.7842583,53.2606113 30.7296255,60 28,60 C25.2703745,60 18.2157417,53.2606113 12.6524709,45.410863 C8.42171119,39.4412816 5,32.6616494 5,27.1361163 C5,20.7466044 7.57482926,14.9617352 11.7385407,10.7744092 C15.9002111,6.58913593 21.6493693,4 28,4 L28,4 Z",
    stroke: "url(#1t7pqdzlnb)",
    strokeWidth: 2,
    fill: "url(#6j85fnrt5c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8892547,2.95158514 L15.7178955,2.95158514 L15.7178955,1.25615322 C15.7178955,0.565305237 14.952026,0 14.0156864,0 L5.94801236,0 C5.0116727,0 4.24555396,0.565305237 4.24555396,1.25615322 L4.24555396,2.95158514 L3.07419478,2.95158514 C1.38344996,2.95158514 0,4.29433627 0,5.93534212 L0,17.0929242 C0,18.734172 1.38344996,20.0769231 3.07419478,20.0769231 L16.8892547,20.0769231 C18.5802487,20.0769231 19.9636987,18.734172 19.9636987,17.0929242 L19.9636987,5.93534212 C19.9636987,4.29433625 18.5802487,2.95158514 16.8892547,2.95158514 Z M14.2597848,12.1162362 C14.2581223,12.6654009 13.7947119,13.1101904 13.2225567,13.1117861 L11.7577746,13.1117861 L11.7577746,14.5184361 C11.7561122,15.0676008 11.2927017,15.5123904 10.7205465,15.513986 L9.24289999,15.513986 C8.67074473,15.5123904 8.2073343,15.0676008 8.20567186,14.5184361 L8.20567186,13.1117861 L6.74013307,13.1117861 C6.16837188,13.1096592 5.70557334,12.6650245 5.70391391,12.1162362 L5.70391391,10.6977228 C5.70557636,10.1485581 6.16898679,9.70376856 6.74114205,9.70217291 L8.20668083,9.70217291 L8.20668083,8.29624921 C8.20834328,7.74708447 8.67175371,7.30229495 9.24390897,7.3006993 L10.7207987,7.3006993 C11.2928555,7.30242782 11.7561129,7.74717862 11.7577746,8.29624921 L11.7577746,9.70314135 L13.2233134,9.70314135 C13.794781,9.7051323 14.2575714,10.1492186 14.2597848,10.6977228 L14.2597848,12.1162362 Z M14.2597848,2.73776224 L5.70391391,2.73776224 L5.70391391,1.74895476 C5.70391391,1.28994323 6.21854144,0.912587413 6.84714013,0.912587413 L13.1158054,0.912587413 C13.7446552,0.912587413 14.2590317,1.28897687 14.2590317,1.74895476 L14.2597848,2.73776224 Z",
    transform: "translate(18.018151 17.898717)",
    fill: "#F7FFFF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYlwsjg);
export default __webpack_public_path__ + "static/media/ylwsjg.513336e965089aaf123209df338b4345.svg";
export { ForwardRef as ReactComponent };